import { render, staticRenderFns } from "./configurationDialogStarter.vue?vue&type=template&id=045c1ddc"
import script from "./configurationDialogStarter.vue?vue&type=script&lang=js"
export * from "./configurationDialogStarter.vue?vue&type=script&lang=js"
import style0 from "./configurationDialogStarter.vue?vue&type=style&index=0&id=045c1ddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports